import { render, staticRenderFns } from "./CCarName.vue?vue&type=template&id=2328b634&"
import script from "./CCarName.vue?vue&type=script&lang=js&"
export * from "./CCarName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports